(ns teamoesterreich.admin-mode.ticket.ticket-modal
  (:require [clojure.string]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.view-state :as vstate]
            [teamoesterreich.admin-mode.data.ticket :as d-ticket]
            [reagent-material-ui.icons.warning :refer [warning]]
            [reagent-material-ui.icons.save :refer [save]]
            [reagent-material-ui.icons.check :refer [check]]
            [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
            [reagent.core :as r]
            [teamoesterreich.util.log :as log]))


(def PRIORITIES {1 "niedrig"
                 2 "mittel"
                 3 "hoch"})
(def STATUS {"new"        "Neu"
             "unsolvable" "Aufgegeben"
             "done"       "Erledigt"})

(defn date-conv [date]
  (if (> (count date) 12)
    (str (subs date 0 4) "-" (subs date 4 6) "-" (subs date 6 8))
    ""
    ))

(defn date-conv-back [date]
  ;2021-06-20 -> 20180701T100000.000Z
  (str (subs date 0 4) (subs date 5 7) (subs date 8 10) "T100000.000Z"))


(defn now-plus-day [days]
  (let [res (js/Date.)
        _ (.setDate res (+ (.getDate res) days))
        y (.getFullYear res)
        m (inc (.getMonth res))
        m (if (> m 9) m (str "0" m))
        d (.getDate res)
        d (if (> d 9) d (str "0" d))]
    (str y m d "T100000.000Z")))

(defn get-initial [] {:dueDate (now-plus-day 14) :subject "Lebensretter Erinnerung" :priority 3})

(defn new-ticket-modal [!show-for-tomId ticket-type callback-fn]
  (let [!st (r/atom (get-initial))
        !subject (r/cursor !st [:subject])
        !body (r/cursor !st [:body])
        !dueDate (r/cursor !st [:dueDate])
        !priority (r/cursor !st [:priority])
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        ]
    (fn []
      [mui/modal
       {
        :aria-labelledby  "simple-modal-title"
        :aria-describedby "simple-modal-description"
        :style            {:display        "flex"
                           :marginRight    "auto"
                           :marginLeft     "auto"
                           :alignItems     "center"
                           :justifyContent "center"}
        :open             (or @!show-for-tomId false)

        }
       [:div
        {
         :class "modal"
         :style {:width 800}}
        [mui/grid {:container  true
                   :direction  "row"
                   :error      (< (count (str (:userDocument-type @!st))) 1)
                   :justify    "space-between"
                   :spacing    2
                   :style      {:paddingRight "5px"}
                   :alignItems "flex-start"}
         [mui/grid {:container false :item true :xs 4}
          [warning {:style {:color "red" :height 60 :width 60 :text-align "center"}}]]
         [mui/grid {:container false :item true :xs 8}
          [:h4 "Ticket: Erinnerung/Warnung (" @!show-for-tomId ")"]
          ]


         [mui/grid {:container false :item true :xs 12}

          [mui/text-field
           {:style           {:backgroundColor (if @!subject "#ffd6d2" "#ffffff")}
            :onChange        (fn [e] (reset! !subject (h/event-value e)))
            :fullWidth       true
            :InputLabelProps {:disableAnimation true :shrink true}
            :label           "Betreff"
            :defaultValue    "Lebensretter Erinnerung"
            :multiline       false
            }]]

         [mui/grid {:container false :item true :xs 12}

          [mui/text-field
           {:style           {:backgroundColor (if @!body "#ffd6d2" "#ffffff")}
            :onChange        (fn [e] (reset! !body (h/event-value e)))
            :fullWidth       true
            :InputLabelProps {:disableAnimation true :shrink true}
            :label           "Beschreibung"
            :multiline       true
            :rows            3
            }]]

         [mui/grid {:container false :item true :xs 6

                    }
          [mui/form-label {:style {:font-size "0.8rem" :backgroundColor (if @!priority "#ffd6d2" "#ffffff")}} "Priorität"
           [mui/select
            {:fullWidth true
             :style     {:backgroundColor (if @!priority "#ffd6d2" "#ffffff")}
             :value     (or @!priority 3)
             :onChange  (fn [e]
                          (js/console.log "Change prio  -> " (h/event-value e))
                          (reset! !priority (h/event-value e)))
             }
            (for [[k v] PRIORITIES]
              ^{:key (str "docTypes-" k)} [mui/menu-item {:style {} :value k} v])
            ]]]

         [mui/grid {:container false :item true :xs 6}
          [mui/text-field
           {:style           {:backgroundColor (if @!dueDate "#ffd6d2" "#ffffff")}
            :fullWidth       true
            :type            "date"
            :label           "Fälligkeit"
            :defaultValue    (date-conv @!dueDate)
            :InputLabelProps {:disableAnimation true :shrink true}
            :onChange        (fn [e]
                               (let [date (date-conv-back (h/event-value e))]
                                 (reset! !dueDate (date-conv-back date))))
            }]
          ]



         [mui/grid {:container false :item true :xs 6}
          [mui/button
           {
            :variant   "contained"
            :startIcon (r/as-element [keyboard-arrow-left])
            :style     {:marginRight 50}
            :onClick   (fn []
                         (reset! !show-for-tomId false))
            }
           "Abbrechen"]
          ]
         [mui/grid {:container false :item true :xs 6}
          [mui/button
           {:style     {:float "right"}
            :color     "secondary"
            :variant   "contained"
            :disabled  (or (< (count @!body) 1) (< (count @!subject) 1) (not @!dueDate))
            :startIcon (r/as-element [save])
            :onClick   (fn [] (d-ticket/>add-new {:ticket-subject (str @!subject)
                                                  :ticket-comment (str @!body)
                                                  :ticket-user    {:user-tomId @!show-for-tomId}
                                                  :ticket-type    ticket-type
                                                  :ticket-status  "new"
                                                  :ticket-dueDate @!dueDate}
                                                 (fn []
                                                   (callback-fn)
                                                   (reset! !st (get-initial))
                                                   (reset! !invalidated true)
                                                   (reset! !show-for-tomId false)
                                                   )))
            }
           "Anlegen"]]
         ]
        ]
       ]
      )))


(defn ticket-modal [!show-ticket-uuid]
  (let [!st (r/atom {:loaded 0 :ticket-uuid nil :ticket {}})
        !loaded (r/cursor !st [:loaded])
        !uuid (r/cursor !st [:ticket-uuid])
        !invalidated (r/cursor vstate/app-state [:lr-list :invalidated])
        !ticket (r/cursor !st [:ticket])]
    (fn []
      (if-not (and @!loaded (= @!uuid @!show-ticket-uuid))
        (do
          ;(log/debug "ticket-modal load " @!uuid @!show-ticket-uuid)
          (d-ticket/<get-by-uuid @!show-ticket-uuid (fn [ticket]
                                                      (log/debug "cb" (clj->js ticket) (:ticket-uuid ticket))
                                                      (swap! !st assoc
                                                             :loaded true
                                                             :ticket-uuid (:ticket-uuid ticket)
                                                             :ticket ticket)))
          [mui/modal
           {
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (if @!show-ticket-uuid true false)

            }

           [:div "Loading ... "]
           ])
        (do
          ;(log/debug "ticket-modal loaded" @!uuid (clj->js @!ticket))
          [mui/modal
           {
            :aria-labelledby  "simple-modal-title"
            :aria-describedby "simple-modal-description"
            :style            {:display        "flex"
                               :marginRight    "auto"
                               :marginLeft     "auto"
                               :alignItems     "center"
                               :justifyContent "center"}
            :open             (if @!show-ticket-uuid true false)

            }

           [:div
            {
             :class "modal"
             :style {:width 800}}
            [mui/grid {:container  true
                       :direction  "row"
                       :error      (< (count (str (:userDocument-type @!st))) 1)
                       :justify    "space-between"
                       :spacing    2
                       :style      {:paddingRight "5px"}
                       :alignItems "flex-start"}
             [mui/grid {:container false :item true :xs 4}
              [warning {:style {:color "red" :height 60 :width 60 :text-align "center"}}]]
             [mui/grid {:container false :item true :xs 8}
              [:h4 "Ticket: Erinnerung/Warnung "]
              ]

             [mui/grid {:container false :item true :xs 9}
              [mui/text-field
               {:fullWidth       true
                :InputLabelProps {:disableAnimation true :shrink true}
                :label           "Betreff"
                :value           (:ticket-subject @!ticket)
                :disabled        true
                :multiline       false
                }]]


             [mui/grid {:container false :item true :xs 3}
              [mui/text-field
               {:fullWidth       true
                :InputLabelProps {:disableAnimation true :shrink true}
                :label           "Status"
                :value           (or (get STATUS (:ticket-status @!ticket)) (:ticket-status @!ticket))
                :disabled        true
                :multiline       false
                }]]

             [mui/grid {:container false :item true :xs 12}

              [mui/text-field
               {:fullWidth       true
                :InputLabelProps {:disableAnimation true :shrink true}
                :label           "Beschreibung"
                :value           (:ticket-comment @!ticket)
                :disabled        true
                :multiline       true
                }]]

             [mui/grid {:container false :item true :xs 6}
              [mui/text-field
               {:fullWidth       true
                :InputLabelProps {:disableAnimation true :shrink true}
                :label           "Priorität"
                :value           (or (get PRIORITIES (:ticket-priority @!ticket)) "?")
                :disabled        true
                :multiline       false
                }]]

             [mui/grid {:container false :item true :xs 6}
              [mui/text-field
               {:fullWidth       true
                :disabled        true
                :type            "date"
                :label           "Fälligkeit"
                :value           (date-conv (:ticket-dueDate @!ticket))
                :InputLabelProps {:disableAnimation true :shrink true}
                }]
              ]




             [mui/grid {:container false :item true :xs 6}
              [mui/button
               {
                :variant   "contained"
                :startIcon (r/as-element [keyboard-arrow-left])
                :style     {:marginRight 50}
                :onClick   (fn []
                             (reset! !show-ticket-uuid nil))
                }
               "Abbrechen"]
              ]

             [mui/grid {:container false :item true :xs 6 :style {:text-align "right"}}
              [mui/button
               {
                :variant   "contained"
                :color     "primary"
                :startIcon (r/as-element [check])
                :style     {:marginRight 50}
                :onClick   (fn []
                             (d-ticket/>set-done @!uuid
                                                 (fn []
                                                   (reset! !invalidated true)
                                                   (reset! !show-ticket-uuid nil))))
                }
               "Erledigt"]
              ]
             ]
            ]
           ]
          )))))